import React from 'react'
import { cn } from "../../../../lib/utils";

export default function TR({children, className, ...props}) {
  return (
    <tr className={cn("hover:bg-light-950 ease-in duration-300 [&_.td-item]:last:border-0", className)} {...props}>{children}</tr>
  )
}
